/**
 * MC answer-option images: `public/assets/{basePath}/{key}.webp` or `.png`.
 */

export const QUIZ_MC_ANSWER_IMAGES_ROOT = '/assets';

function quizImageAssetOriginPrefix(): string {
  const raw = process.env.REACT_APP_IMAGE_ASSET_ORIGIN;
  if (raw == null || !String(raw).trim()) return '';
  return String(raw).trim().replace(/\/$/, '');
}

export function quizMcAnswerImageUrlsFromKey(
  basePath: string | null | undefined,
  key: string | null | undefined
): { webp: string; png: string } | null {
  const b = sanitizePathSegment(basePath);
  const k = sanitizeFileKey(key);
  if (!b || !k) return null;
  const origin = quizImageAssetOriginPrefix();
  const pub = origin ? '' : process.env.PUBLIC_URL || '';
  const pathAfterOrigin = `${pub}${QUIZ_MC_ANSWER_IMAGES_ROOT}/${b}/${k}`;
  const base = origin ? `${origin}${pathAfterOrigin}` : pathAfterOrigin;
  return { webp: `${base}.webp`, png: `${base}.png` };
}

function sanitizePathSegment(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  const t = raw.trim().replace(/\\/g, '/');
  if (t.includes('..')) return null;
  const segments = t.split('/').filter(Boolean);
  for (const seg of segments) {
    if (!/^[a-zA-Z0-9 _-]+$/.test(seg)) return null;
  }
  return segments.join('/');
}

function sanitizeFileKey(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  let s = raw.trim();
  const lower = s.toLowerCase();
  if (lower.endsWith('.png')) s = s.slice(0, -4).trim();
  else if (lower.endsWith('.webp')) s = s.slice(0, -5).trim();
  if (!s || !/^[a-zA-Z0-9_-]+$/.test(s)) return null;
  return s;
}
